import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/column';

export const mergeColumn = createAction(types.MERGE_COLUMN);
export const moveColumn = createAction(types.MOVE_COLUMN);
export const splitColumn = createAction(types.SPLIT_COLUMN);
export const updateColumnSizing = createAction(types.UPDATE_COLUMN_SIZING);
